import React from 'react';

import { ADMIN_GENERAL_PLATFORM } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { SettingsIcon } from '@Generic/icons';
import {
  PLATFORM_SETTINGS_TAB_GROUPS,
  PLATFORM_SETTINGS_TABS,
} from '../../../pages/Admin/PlatformSettings/PlatformSettingsTabs';
import { PLATFORM_SETTINGS_URL } from '@ApplicationWide/routes/admin/admin-urls';

const PlatformSettingsPage = React.lazy(() => import('../../../pages/Admin/PlatformSettings/PlatformSettingsPage'));

const PLATFORM_SETTINGS_TAB_IDS = PLATFORM_SETTINGS_TABS.map((tab) => tab.id).join('|');
const PLATFORM_SETTINGS_TAB_GROUP_IDS = PLATFORM_SETTINGS_TAB_GROUPS.map((tabGroup) => tabGroup.id).join('|');

export default {
  label: 'navigation.admin.platform-settings',
  group: ADMIN,
  to: `${PLATFORM_SETTINGS_URL}/platform/general`,
  route: `${PLATFORM_SETTINGS_URL}/:tabGroupId(${PLATFORM_SETTINGS_TAB_GROUP_IDS})/:tabId(${PLATFORM_SETTINGS_TAB_IDS})`,
  component: PlatformSettingsPage,
  icon: <SettingsIcon />,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_GENERAL_PLATFORM,
  area: ADMIN_GENERAL_PLATFORM,
  hasNavBar: true,
};
